export const debounce = (fn, time) => {
  return function(...args) {
    const functionCall = () => fn.apply(this, args);
    return setTimeout(functionCall, time);
  };
};

export const cancelDebounce = id => clearTimeout(id);
